import React from "react";
import './../table.css';
import { groupDivisionProgramSummery } from "../utils";
export default (({ referralData = [] }) => {

    // const divisonTableData = groupDivisionProgramSummery(referralData);


    return <>
        <div className="d-flex justify-content-between w-full align-items-center">
            <h5 className="heading3">
                Division & Programme summary
            </h5>
            <div>
                <div className="badge me-4" style={{
                    backgroundColor: "#e0faff", color: 'black', paddingTop: 7,
                    height: 50, width: 120
                }}>
                    <h6>{referralData.onboardedUser}</h6>
                    <span>Total Onboarded</span>
                </div>
                <span className="badge" style={{
                    background: '#D8CDFB 0% 0% no-repeat padding-box',
                    boxShadow: '0px 1px 3px #0000000A',
                    color: 'black', paddingTop: 7,
                    height: 50, width: 110
                }}>
                    <h6>{referralData.total}</h6>
                    <span>Account Created</span>
                </span>
            </div>
        </div>
        <table className="table table-bordered  mt-6 bg-white shadow table_border remove_strap">
            <thead className="custom-header" >
                <tr>
                    <th>Division</th>
                    <th>Account Created</th>
                    <th>Programme</th>
                </tr>
            </thead>
            <tbody>
                {referralData?.data.map((group, index) => (
                    <React.Fragment key={`frag2_${index}`}>
                        {group.programs.map((program, i) => (
                            <tr key={`key_${i}`}>
                                {i === 0 && (
                                    <td rowSpan={group.programs.length}
                                        className="tdRowspan">
                                        <p> {group.areaName}</p>
                                        <div className="rowspan">
                                            {group.areaName}
                                        </div>
                                    </td>
                                    // <td rowSpan={group.programs.length}>
                                    //     {group.areaName}
                                    // </td>
                                )}
                                <td>{program.count}</td>
                                <td>{program.name}</td>
                            </tr>
                        ))}


                    </React.Fragment>
                ))}
            </tbody>
        </table>
    </>
});